import { timeToMilitary } from './timeToMilitary.js';

export function validateAddAlertFormData(formData, setMessage, setLoading) {
    
    //Make sure required fields are filled
    if (!formData.departStation || !formData.arriveStation || !formData.travelDate || !formData.maxPrice || !formData.minArrivalTime ||!formData.phoneNumber ) { 
        setMessage({type: 'error', text: 'Please fill in all required fields.',});
        setLoading(false);
        return;
    }
    
    // Validate stations are different
    if (formData.departStation === formData.arriveStation) {
        setMessage({type: 'error', text: 'Departure and arrival stations must be different.',});
        setLoading(false);
        return;
    }
    
    // Validate price
    if (isNaN(formData.maxPrice) || Number(formData.maxPrice) <= 0) {
        setMessage({ type: 'error', text: 'Max price must be a positive number.'});
        setLoading(false);
        return;
    }
    
    // Convert time format to HHMM
    const minTime = timeToMilitary(formData.minArrivalTime);
    const maxTime = timeToMilitary(formData.maxArrivalTime);
    
    //Validate times
    if (minTime === null) {
        setMessage({ type: 'error', text: 'Please enter a valid minimum arrival time.'});
        setLoading(false);
        return;
    }
    
    if (maxTime === null) {
        setMessage({ type: 'error', text: 'Please enter a valid maximum arrival time.'});
        setLoading(false);
        return;
    }
}